import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { LAYER, useSmartClosePopups } from 'js/components/common/PopupManager';
import { closePopupsAction } from 'js/components/common/PopupManager/store/actions';
import { useConfirmationPopup } from 'js/components/common/popups/ConfirmationPopup';

import * as pas from '../../../pas';
import { VALIDATION_TYPE } from '../constants';

export const useValidateFitToPlay = () => {
    const dispatch = useDispatch();
    const closePopups = useSmartClosePopups();
    const showConfirmationPopup = useConfirmationPopup();

    return useCallback((pasLoginResponse, options = {}) => new Promise((resolve, reject) => {
        const { sessionValidationData = {} } = pasLoginResponse?.data || {};

        const sendFitToPlay = ({ fitToPlay }) => {
            (async () => {
                try {
                    await pas.validateFitToPlayToken(fitToPlay);
                    dispatch(closePopupsAction({ popups: [VALIDATION_TYPE.FIT_TO_PLAY] }));

                    if (fitToPlay) {
                        resolve();
                    } else {
                        reject(pasLoginResponse);
                    }
                } catch (error) {
                    reject(error);
                }
            })();
        };

        if (!sessionValidationData.SessionValidationByFitToPlayData) {
            resolve();

            return;
        }

        if (options.fitToPlay) {
            sendFitToPlay({ fitToPlay: true });
        } else {
            showConfirmationPopup({
                isModal: true,
                id: VALIDATION_TYPE.FIT_TO_PLAY,
                layer: LAYER.SESSION_VALIDATION,
                title: 'playtech.mobile.system.popup.fitToPlay.title',
                content: 'playtech.mobile.system.popup.fitToPlay.text',
                acceptBtnText: 'playtech.mobile.system.message.confirm',
                declineBtnText: 'playtech.mobile.system.message.decline',
                onAccept:() => sendFitToPlay({ fitToPlay: true }),
                onDecline: () => {
                    sendFitToPlay({ fitToPlay: false });
                    closePopups({ excludeLayers: [LAYER.LOGIN] });
                }
            });
        }
    }), [
        showConfirmationPopup, closePopups, dispatch
    ]);
};
